import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if (window.Contrack && window.Contrack.SentryDSN) {
	Sentry.init({
		environment: window.Contrack.Environment,
		dsn: window.Contrack.SentryDSN,
		release: "contrack@" + process.env.npm_package_version,
		integrations: [new Integrations.BrowserTracing()],

		// We recommend adjusting this value in production, or using tracesSampler
		// for finer control
		tracesSampleRate: 1.0,
	});
}